import React, { Component } from "react";
import $ from "jquery";

import css from "./SisSelect.module.scss";
import { MdRestaurantMenu } from "react-icons/md";

class SisSelect extends Component {
	constructor(props) {
		super(props);

		this.initClick = true;
	}

	componentDidMount() {
		const self = this;

		setTimeout(() => {
			self.selectBox.value = self.props.defaultValue ? self.props.defaultValue : "-";

			if (self.props.id === "selectTransportationSgg") {
				// console.log(self.selectBox.value);
			}

			if (self.props.onLoaded) {
				// const val = this.props.defaultValue
				self.props.onLoaded(self.selectBox.value);
			}
		}, 100);
	}

	componentDidUpdate(prevProps, prevState) {
		const prevItems = prevProps.items ? prevProps.items : [];
		const curItems = this.props.items ? this.props.items : [];

		// if (prevProps.items.length === 0) return;

		const strPrevItems = prevItems.map((item) => {
			return JSON.stringify(item);
		});

		const strCurItems = curItems.map((item) => {
			return JSON.stringify(item);
		});

		if (strPrevItems.toString() !== strCurItems.toString()) {
			this.refresh();
		} else {
			// if (this.props.defaultValue) if (this.selectBox.value.toString() !== this.props.defaultValue.toString()) this.refresh();
		}

		// if (prevProps.items.length === 0 && this.props.items.length > 0) {
		// 	if (this.props.onLoaded) {
		// 		this.props.onLoaded(this.selectBox.value);
		// 	}
		// }
		// if (prevProps.items.length > 0 && this.props.items.length > 0) {
		// 	if (this.props.mapping) {
		// 		if (prevProps.items[0][this.props.mapping.key] !== this.props.items[0][this.props.mapping.key]) {
		// 			if (this.props.onChange) this.props.onChange(this.selectBox.value);
		// 		}
		// 	} else {
		// 		if (prevProps.items[0].key !== this.props.items[0].key) {
		// 			if (this.props.onChange) this.props.onChange(this.selectBox.value);
		// 		}
		// 	}
		// }
	}

	// div option 선택 이벤트
	changeHandler = (value) => {
		const option = $(this.selectBox).find(`option[value=${value}]`);

		if (option.length > 0) {
			$(option[0]).trigger("click");
		}
	};

	// 셀렉트박스 클릭 이벤트
	clickHandler = (evt) => {
		$(this.selectItemWrap).toggleClass(css.active);

		const display = $(this.options).css("display");

		if (display === "block") {
			setTimeout(() => {
				$(this.options).toggle();

				$(this.options).css({
					overflow: "hidden",
				});
			}, 100);
		} else {
			$(this.options).toggle();
		}

		$(this.options).css({
			width: this.sisSelect.clientWidth,
			overflow: "auto",
			// visibility: "visible",
		});
		$(this.options).scrollTop(0);

		$(document).one("click", this.focusOut);
	};

	// 진짜 셀렉트박스 change 이벤트
	selectboxChange = (evt) => {
		const val = evt.target.value;
		evt.target.selected = true;

		this.selectBox.value = val;
		$(this.selectItemText).text(evt.target.text).attr("value", val);

		if (this.props.onChange) {
			this.props.onChange(val);
		}
	};

	focusOut = (evt) => {
		// // console.log("focusout");
		$(this.selectItemWrap).removeClass(css.active);
		$(this.options).css({ overflow: "hidden" });
		setTimeout(() => {
			$(this.options).hide();
		}, 100);
	};

	refresh = () => {
		// console.log(`${this.props.id} refresh`);
		if (this.props.defaultValue) {
			if (this.props.defaultValue === this.selectBox.value) return;

			if (this.selectBox.options.length > 0) {
				const option = $(this.selectBox).find(`option[value=${this.props.defaultValue}]`);

				if (option.length > 0) {
					$(option[0]).trigger("click");
				}
			}
		} else {
			if (this.selectBox.options.length > 0) {
				this.selectBox.options[0].click();
			}
		}
	};

	render() {
		const {
			id,
			items,
			mapping,
			title,
			className,
			defaultValue,
			// onChange,
		} = this.props;

		let selectedItem = (
			<span className={css.selectedItem} ref={(ref) => (this.selectItemText = ref)} value="0">
				=== 전체 ===
			</span>
		);

		if (items.length > 0) {
			if (defaultValue) {
				selectedItem = items.map((item, idx) => {
					const key = mapping ? item[mapping.key] : item.key;
					const text = mapping ? item[mapping.text] : item.text;

					if (key === defaultValue) {
						return (
							<span className={css.selectedItem} ref={(ref) => (this.selectItemText = ref)} key={key + idx} value={key}>
								{text}
							</span>
						);
					}

					return null;
				});
			} else {
				if (this.props.placeholder) {
					selectedItem = (
						<span className={css.selectedItem} ref={(ref) => (this.selectItemText = ref)} style={{ color: "rgba(191,191,191,.87)" }}>
							{this.props.placeholder ? this.props.placeholder : ""}
						</span>
					);
				} else {
					if (items.length > 0) {
						const key = mapping ? items[0][mapping.key] : items[0].key;
						const text = mapping ? items[0][mapping.text] : items[0].text;

						selectedItem = (
							<span className={css.selectedItem} ref={(ref) => (this.selectItemText = ref)} value={key}>
								{text}
							</span>
						);
					}
				}
			}
		}

		return (
			<div className={`${css.selectWrap} ${className}`}>
				{/* 셀렉트박스 앞에 나타날 문구 */}
				{title ? (
					<div className={css.title}>
						<span>{title}</span>
					</div>
				) : (
					""
				)}
				<div id={id} className={css.sisSelect} ref={(ref) => (this.sisSelect = ref)}>
					{/* 현재 선택된 아이템 */}
					<div ref={(ref) => (this.selectItemWrap = ref)} className={css.selectedItemWrap} onClick={this.clickHandler}>
						{selectedItem}
					</div>

					{/* 예쁘게 보여지는 option */}
					<div className={`${css.items}`} ref={(ref) => (this.options = ref)}>
						{items.length > 0 ? (
							items.map((item, idx) => {
								const key = mapping ? item[mapping.key] : item.key;
								const text = mapping ? item[mapping.text] : item.text;

								return (
									<div className={css.item} value={key} key={key + idx} onClick={() => this.changeHandler(key)}>
										{text}
									</div>
								);
							})
						) : (
							<div className={css.item} value="0">
								=== 전체 ===
							</div>
						)}
					</div>
				</div>

				{/* hidden selectbox */}
				<label htmlFor={id}></label>
				<select id={id} ref={(ref) => (this.selectBox = ref)}>
					{items ? (
						items.map((item, idx) => {
							const key = mapping ? item[mapping.key] : item.key;
							const text = mapping ? item[mapping.text] : item.text;

							return (
								<option value={key} key={key + idx} onClick={this.selectboxChange}>
									{text}
								</option>
							);
						})
					) : (
						<option value="0">=== 전체 ===</option>
					)}
				</select>
			</div>
		);
	}
}

export default SisSelect;
